import React from 'react';

import { styled, absoluteFill } from '~/styles';

const IframeContainer = styled.div`
  ${absoluteFill};

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

function TrainingModuleModal(props) {
  const config = props.config;

  return (
    <IframeContainer>
      <iframe title='Module' src={config.url} />
    </IframeContainer>
  );
}

export default TrainingModuleModal;



// WEBPACK FOOTER //
// ./src/components/modals/TrainingModuleModal.tsx